/*! @azure/msal-browser v2.38.4 2024-03-26 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.38.4";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
